import { Button, Stack, styled, Typography, Box, IconButton } from '@mui/material';
import { HeaderClient } from '../../elements/HeaderClient';
import React from 'react';
import { useInjection } from './hook';
import { TableInfiniteScroll } from 'app/components/elements/TableInfiniteScroll';
import { Location, SearchType } from 'types/loctions';
import { TextEllipsis } from '../../../../../components/elements/TextEllipsis';
import {
  isRoomLocationLevel,
  isVerticalLocationLevel,
  renderTitle
} from 'utils/renderTitleLocation';
import { InputSelect } from '../../../../../components/elements/InputSelect';
import { useAuth } from 'contexts/auth';
import { Role } from 'const/common';
import { DialogConfirm } from 'app/components/elements/DialogConfirm';
import { ModalReparentLocation } from 'app/pages/LocationPage/ModalReparentLocation';
import { ModalEditLocationName } from 'app/pages/LocationPage/ModalEditLocationName';

const optionSearchType = [
  { label: 'Partial Text', value: 'partial-text' },
  { label: 'Full text', value: 'full-text' }
];
export const FloorPlanLocationPage = () => {
  const {
    locations,
    fetchMoreData,
    hasMore,
    handleSearch,
    onSortHeader,
    searchParams,
    handleBack,
    paths,
    onClickAction,
    clientId,
    clientName,
    title,
    header,
    pathLastRoom,
    isFreeSearch,
    listButton,
    handleNavigateLastRoom,
    searchType,
    setSearchType,
    locationDelete,
    setLocationDelete,
    locationReparent,
    setLocationReparent,
    locationRename,
    setLocationRename,
    handleDeleteLocation,
    handleGetInitLocations
  } = useInjection();
  const { auth } = useAuth();
  const isCanAddRoom = auth?.role ? [Role.ADMIN, Role.SUPER_ADMIN].includes(auth?.role) : false;
  const renderDataMap = (locations: Location[]) => {
    return locations?.map((location) => {
      const isVerticalLevel = isVerticalLocationLevel(location.level);
      const isRoomLevel = isRoomLocationLevel(location.level);
      return {
        name: {
          value: (
            <TextEllipsis
              onClick={() => {
                isRoomLevel
                  ? onClickAction({
                    href: `/inspection/${clientName}/${clientId}/location/${location.id}/plans`,
                    path: location.name,
                    locationId: location.id
                  })
                  : onClickAction({
                    href: `/inspection/${clientName}/${clientId}/location/${location.id}`,
                    path: location.name,
                    locationId: location.id
                  });
              }}
              text={
                isFreeSearch
                  ? `${location.name} - ${renderTitle(location.level).title}`
                  : location.name
              }
              styles={{ textDecoration: 'underline', cursor: 'pointer', color: '#226AAA' }}
              width={'80%'}
            />
          )
        },
        actions: {
          value: isVerticalLevel ? (
            <Stack flexDirection="row" gap={1}>
              <Button
                onClick={() => {
                  onClickAction({
                    href: `/inspection/${clientName}/${clientId}/location/${location.id}`,
                    path: location.name,
                    locationId: location.id,
                  });
                }}
              >
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  View Rooms
                </Typography>
              </Button>

              <Button
                onClick={() => {
                  onClickAction({
                    href: `/inspection/${clientName}/${clientId}/location/${location.id}/plans`,
                    path: location.name,
                    locationId: location.id,
                  });
                }}
              >
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  View Plans
                </Typography>
              </Button>
              <Button
                onClick={() => {
                  onClickAction({
                    href: `/inspection/${clientName}/${clientId}/location/${location.id}/update`,
                    path: location.name,
                    locationId: location.id,
                  });
                }}
              >
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  Update Plan
                </Typography>
              </Button>
              <IconButton
                onClick={() => {
                  setLocationDelete(location);
                }}>
                <img alt={'icon-user'} src={'/icons/icon_delete.svg'} width={24} />
              </IconButton>
            </Stack>
          ) : isRoomLevel ? (
            <Stack flexDirection="row" gap={1}>
              <Button
                onClick={() => {
                  onClickAction({
                    href: `/inspection/${clientName}/${clientId}/location/${location.id}/plans`,
                    path: location.name,
                    locationId: location.id,
                  });
                }}
              >
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  View Plans
                </Typography>
              </Button>
              <Button
                onClick={() => {
                  onClickAction({
                    href: `/inspection/${clientName}/${clientId}/location/${location.id}/update`,
                    path: location.name,
                    locationId: location.id,
                  });
                }}
              >
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  Update Plan
                </Typography>
              </Button>
              <IconButton
                onClick={() => {
                  setLocationDelete(location);
                }}>
                <img alt={'icon-user'} src={'/icons/icon_delete.svg'} width={24} />
              </IconButton>
            </Stack>
          ) : (
            <Stack flexDirection="row" gap={1}>
              <Button
                onClick={() => {
                  onClickAction({
                    href: `/inspection/${clientName}/${clientId}/location/${location.id}`,
                    path: location.name,
                    locationId: location.id,
                  });
                }}
              >
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  View
                </Typography>
              </Button>
              {isCanAddRoom && (
                <>
                  <Button onClick={() => setLocationRename(location)}>
                    <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                      Rename
                    </Typography>
                  </Button>
                  <Button onClick={() => setLocationReparent(location)}>
                    <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                      Move
                    </Typography>
                  </Button>
                  <IconButton
                    onClick={() => {
                      setLocationDelete(location);
                    }}>
                    <img alt={'icon-user'} src={'/icons/icon_delete.svg'} width={24} />
                  </IconButton>
                </>
              )}
            </Stack>
          ),

        }
      };
    });
  };
  return (
    <WrapperCreatePage>
      <HeaderClient
        onShowLastRoom={pathLastRoom ? handleNavigateLastRoom : undefined}
        buttons={listButton}
        title={title.title}
        // valueFilterType={searchParams.get('type') || ''}
        onSearch={handleSearch}
        searchholder='Search'
        // onFilterType={filterByTypeAccess}
        // onFilterClient={() => {}}
        // optionFilterClient={optionTypeAccess}
        // optionFilterType={optionTypeAccess}
        textButton={'Back'}
        isSearch={isFreeSearch}
        onClickButton={handleBack}
        paths={paths}
      />
      <Stack style={{ width: 'fit-content', gap: '8px' }}>
        <Typography
          style={{
            fontWeight: '700',
            color: '#226AAA',
            whiteSpace: 'nowrap'
          }}>
          Search Type
        </Typography>
        <InputSelect
          style={{ minHeight: 'auto', height: '48px' }}
          value={searchType}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onChange={(e: any) => setSearchType(e.target.value as SearchType)}
          options={optionSearchType}
        />
      </Stack>
      <Stack id={'id-table-clients'} sx={{ height: 'calc(100% - 230px)', overflow: 'scroll' }}>
        {locations?.length ?
          <TableInfiniteScroll
            sort={{
              field: searchParams.get('sortBy') || '',
              order: searchParams.get('order') || ''
            }}
            onSortHeader={onSortHeader}
            idElementScroll={'id-table-clients'}
            data={renderDataMap(locations)}
            handleFetchMore={fetchMoreData}
            headers={header}
            hasMore={hasMore}
            handleChooseRow={() => { }}
            styledTableRow={{ cursor: ' default ' }}
          />
          : <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Typography color="#6B7280">
              {title.level < 4 ? "No Location" : "No Floor Plan"}
            </Typography>
          </Box>
        }
      </Stack>
      <DialogConfirm
        isOpen={Boolean(locationDelete)}
        onClose={() => setLocationDelete(undefined)}
        textTitle="Delete Location"
        textContent={`Are you sure you want to delete this location ${locationDelete?.name}?`}
        onSubmit={handleDeleteLocation}
        textButton={'Delete'}
      />
      {clientId && (
        <>
          <ModalReparentLocation
            open={Boolean(locationReparent)}
            location={locationReparent ?? null}
            clientId={clientId}
            onClose={() => setLocationReparent(undefined)}
            onSuccess={() => void handleGetInitLocations()}
          />
          <ModalEditLocationName
            open={Boolean(locationRename)}
            location={locationRename ?? null}
            onClose={() => setLocationRename(undefined)}
            onSuccess={() => void handleGetInitLocations()}
          />
        </>
      )}
    </WrapperCreatePage>
  );
};

const WrapperCreatePage = styled(Stack)(() => ({
  padding: '40px 30px 30px 40px',
  width: '100%',
  height: '100vh',
  gap: '20px'
}));
